import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { useMemo } from 'react';

import { Chart } from './utils';

import type { TotalActionsRowItem } from '@/app/types/Dashboard';

import './styles.css';
interface Props {
	data: TotalActionsRowItem[];
}

const PieChartTotalActions = ({ data }: Props) => {
	const options = useMemo(() => {
		return Chart.toTotalActionsOptions(data);
	}, [data]);

	return <HighchartsReact options={options} highcharts={Highcharts} />;
};

export default PieChartTotalActions;
